// Store creation mock service
// Persists step data incrementally and assembles a final store object for dashboard mock usage.

const STEP_KEY = "mock.store.creation.v1"; // incremental steps
const FINAL_KEY = "mock.store.final.v1"; // assembled store
const FLAG_FULL = "mock.full.dashboard.enabled";

export function saveStepData(step, data) {
  const current = JSON.parse(localStorage.getItem(STEP_KEY) || "{}");
  current[step] = data;
  localStorage.setItem(STEP_KEY, JSON.stringify(current));
}

export function getCreationData() {
  try {
    return JSON.parse(localStorage.getItem(STEP_KEY) || "{}");
  } catch {
    return {};
  }
}

function assembleFinalStore(steps) {
  const step1 = steps.step1 || {}; // store type choice
  const step2 = steps.step2 || {}; // individual/company base info
  const step3 = steps.step3 || {}; // address
  const step4 = steps.step4 || {}; // details
  const step5 = steps.step5 || {}; // cnaes

  return {
    id: step4.storeCode || `STORE-${Date.now()}`,
    name: step2.nameFantasy || step2.corporateName || "Minha Loja",
    type: step2.type || "Desconhecido",
    storeType: step1.storeType || "pf",
    storeTypeTitle: step1.storeTypeTitle || "Pessoa Física",
    docType: step2.docType,
    document: step2.document,
    responsible: step2.responsible,
    corporateName: step2.corporateName || null,
    crt: step2.crt || null,
    logo: step2.logo || null,
    address: {
      cep: step3.cep || null,
      country: step3.country || null,
      state: step3.state || null,
      city: step3.city || null,
      neighborhood: step3.neighborhood || null,
      street: step3.street || null,
      number: step3.number || null,
      complement: step3.complement || null,
    },
    details: {
      description: step4.description || null,
      category: step4.category || null,
      supportEmail: step4.supportEmail || null,
      contactPhone: step4.contactPhone || null,
    },
    cnaes: (step5.cnaes || []).map(c => ({ code: c.code, description: c.description })),
    createdAt: new Date().toISOString(),
    _mock: true,
  };
}

export function getFinalMockStore() {
  try {
    const raw = localStorage.getItem(FINAL_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearMockStore() {
  try {
    localStorage.removeItem(STEP_KEY);
    localStorage.removeItem(FINAL_KEY);
    localStorage.removeItem(FLAG_FULL);
  } catch {}
}

export async function submitCreation() {
  const steps = getCreationData();
  const finalStore = assembleFinalStore(steps);
  // Simulate API post (placeholder)
  // In real implementation: await api.post('/stores', finalStore)
  localStorage.setItem(FINAL_KEY, JSON.stringify(finalStore));
  localStorage.setItem(FLAG_FULL, "true");
  return { ok: true, store: finalStore };
}
